import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTooth, faChartBar, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const OralHealthReport = ({ id, type, data }) => {
    // Placeholder data
    const oralData = data || {
        overallHealth: {
            score: 68,
            status: 'Moderate',
            color: '#f0ad4e'
        },
        microbiome: [
            { name: 'Streptococcus', percentage: 32, status: 'Normal' },
            { name: 'Lactobacillus', percentage: 18, status: 'High' },
            { name: 'Actinomyces', percentage: 15, status: 'Normal' },
            { name: 'Prevotella', percentage: 12, status: 'Low' },
            { name: 'Fusobacterium', percentage: 8, status: 'High' },
            { name: 'Other', percentage: 15, status: 'N/A' }
        ],
        riskFactors: [
            { name: 'Cavity Risk', level: 'Moderate', description: 'Elevated levels of cavity-causing bacteria' },
            { name: 'Gum Disease', level: 'Low', description: 'Normal levels of periodontal pathogens' },
            { name: 'Bad Breath', level: 'High', description: 'Elevated volatile sulfur compound producers' }
        ]
    };

    return (
        <div className="OmicsView-oral-report">
            <h3>Oral Health Report for {id}</h3>
            <div className="OmicsView-oral-content">
                <div className="OmicsView-oral-section">
                    <h4>
                        <FontAwesomeIcon icon={faTooth} /> Overall Oral Health
                    </h4>
                    <div className="OmicsView-oral-health-score">
                        <div 
                            className="OmicsView-oral-score-circle"
                            style={{ 
                                background: `conic-gradient(${oralData.overallHealth.color} ${oralData.overallHealth.score}%, #e0e0e0 0)` 
                            }}
                        >
                            <div className="OmicsView-oral-score-inner">
                                <span className="OmicsView-oral-score-value">{oralData.overallHealth.score}</span>
                                <span className="OmicsView-oral-score-percent">%</span>
                            </div>
                        </div>
                        <div className="OmicsView-oral-score-status">
                            {oralData.overallHealth.status} Health
                        </div>
                    </div>
                </div>
                
                <div className="OmicsView-oral-section">
                    <h4>
                        <FontAwesomeIcon icon={faChartBar} /> Oral Microbiome
                    </h4>
                    <div className="OmicsView-oral-microbiome">
                        {oralData.microbiome.map((microbe, index) => (
                            <div key={index} className="OmicsView-oral-microbe">
                                <div className="OmicsView-oral-microbe-name">
                                    {microbe.name}
                                </div>
                                <div className="OmicsView-oral-microbe-bar-container">
                                    <div 
                                        className={`OmicsView-oral-microbe-bar status-${microbe.status.toLowerCase()}`}
                                        style={{ width: `${microbe.percentage}%` }}
                                    ></div>
                                </div>
                                <div className="OmicsView-oral-microbe-percentage">
                                    {microbe.percentage}%
                                </div>
                                {microbe.status !== 'N/A' && (
                                    <div className={`OmicsView-oral-microbe-status status-${microbe.status.toLowerCase()}`}>
                                        {microbe.status}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                
                <div className="OmicsView-oral-section">
                    <h4>
                        <FontAwesomeIcon icon={faExclamationTriangle} /> Risk Factors
                    </h4>
                    <div className="OmicsView-oral-risks">
                        {oralData.riskFactors.map((risk, index) => (
                            <div key={index} className={`OmicsView-oral-risk level-${risk.level.toLowerCase()}`}>
                                <div className="OmicsView-oral-risk-header">
                                    <span className="OmicsView-oral-risk-name">{risk.name}</span>
                                    <span className="OmicsView-oral-risk-level">{risk.level} Risk</span>
                                </div>
                                <div className="OmicsView-oral-risk-description">
                                    {risk.description}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OralHealthReport;
